import { FC } from 'react';
import { Box, FormControl, FormHelperText, Slider, Stack, TextFieldProps, Typography } from '@mui/material';
import { useField, useFormikContext } from 'formik';

export type PositiveMoodInputProps = TextFieldProps & {
  name: string;
  label: string;
};

export const PositiveMoodInput: FC<PositiveMoodInputProps> = ({ name }) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const value = field.value ?? 5;
  const distToMin = Math.abs(value - 0);
  const distToMax = Math.abs(value - 10);
  const boldMin = distToMin < distToMax ? 'bold' : 'normal';
  const boldMax = distToMax < distToMin ? 'bold' : 'normal';

  return (
    <FormControl fullWidth margin="normal">
      <Box px={2}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography fontWeight={boldMin}>0</Typography>
          <Slider
            value={value}
            onChange={(_, val) => setFieldValue(name, val)}
            onMouseDown={() => {
              if (field.value === undefined || field.value === null) setFieldValue(name, 5);
            }}
            onTouchStart={() => {
              if (field.value === undefined || field.value === null) setFieldValue(name, 5);
            }}
            min={0}
            max={10}
            step={1}
            valueLabelDisplay="auto"
            marks
          />
          <Typography fontWeight={boldMax}>10</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" sx={{ mt: 1 }}>
          <Stack alignItems="flex-start">
            <Typography fontSize={boldMin === 'bold' ? '2rem' : '1.5rem'}>😐</Typography>
            <Typography variant="body2" fontWeight={boldMin}>
              Not positive
            </Typography>
          </Stack>
          <Stack alignItems="flex-end">
            <Typography fontSize={boldMax === 'bold' ? '2rem' : '1.5rem'}>😊</Typography>
            <Typography variant="body2" fontWeight={boldMax}>
              Very positive
            </Typography>
          </Stack>
        </Stack>
      </Box>
      {meta.touched && meta.error && <FormHelperText error>{meta.error}</FormHelperText>}
    </FormControl>
  );
};
